export const SETTINGS_LAYOUT = 'SETTINGS_LAYOUT';

const initialState = {
  settings: {
    openSidebar: true,
    openDrawerEnd: true,
    intro: true,
    guia: false,
  },
};

export const templateReducer = (state = initialState, action) => {
  switch (action.type) {
    case SETTINGS_LAYOUT:
      return {
        ...state,
        settings: action.payload,
      };
    // case LOGOUT:
    //   return {
    //     ...state,
    //     ...initialState,
    //   };
    default:
      return state;
  }
};
